<template>
  <b-button @click="logout" variant="primary" class="p-2 d-flex">
    <logout class="align-self-center" title="" />
    <p class="m-0 align-self-center">Cerrar Sesión</p>
  </b-button>
</template>

<script>
import Logout from "vue-material-design-icons/Logout.vue";

export default {
  components: {
    logout: Logout
  },
  methods: {
    async logout() {
      await this.$store.dispatch("deAuth");
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="scss" scoped></style>
